// extracted by mini-css-extract-plugin
export default {"smartRater":"style_smartRater__5Iccm"};